import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import ShipperSettings from './ShipperSettings';
import ManageNotifications from '../../notifications/manage-notifications';
import { getCustomerV2 } from '../../../../utils/CustomersAPIUtils';
const NotificationsPage = () => {
    const params = useParams();
    const id = params.id;
    const { t } = useTranslation();
    const [user, setUser] = useState();
    async function fetchUser() {
        const user = await getCustomerV2(id);
        setUser(user);
    }
    useEffect(() => {
        fetchUser();
    }, []);
    const renderSidebar = () => {
        return React.createElement(ShipperSettings, { userId: id, activePage: "notifications" });
    };
    const breadcrumbs = {
        pages: [
            {
                name: (user === null || user === void 0 ? void 0 : user.company_name) || t('SHIPPER'),
                href: `/users/${id}`,
                current: false,
            },
            {
                name: titleize(t('NOTIFICATION', { count: 2 })),
                href: `/users/${id}/settings/notifications`,
                current: true,
            },
        ],
    };
    return (React.createElement(LayoutWithSidebar, { sidebar: renderSidebar, breadcrumbs: breadcrumbs, className: "py-4" }, user && React.createElement(ManageNotifications, { userNotificationPreferences: user })));
};
export default NotificationsPage;
